function CRUDTableRow({ children, onClick }) {
  return (
    <tr onClick={onClick} style={{ cursor: onClick ? "pointer" : "default" }}>
      {children}
    </tr>
  )
}

export default CRUDTableRow